import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate();

  const handleNavClick = (e) => {
    if (!e || !e.target || !e.target.id) {
      return;
    }
    switch (e.target.id) {
      case "home":
        navigate("/");
        break;
      case "blog":
        navigate("/read");
        break;
      case "games":
        navigate("/play");
        break;
      case "contact":
        navigate("/contact");
        break;
      default:
        break;
    }
  };

  return (
    <header className="main-container line-top row-bottom">
      <div className="main-inner">
        <div className="header-container">
          <div className="header-inner">
            <button
              key="1"
              id="home"
              onClick={handleNavClick}
              sx={{ my: 2, color: "white", display: "block" }}
              className="nav-item"
            >
              Home
            </button>
            {/* <button
              key="2"
              id="blog"
              onClick={handleNavClick}
              className="nav-item"
            >
              Read
            </button>
            <button
              key="3"
              id="games"
              onClick={handleNavClick}
              className="nav-item"
            >
              Play
            </button> */}
            <button
              key="4"
              id="contact"
              onClick={handleNavClick}
              className="nav-item"
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
